<template>
  <div id="dashboard">
    <!-- <transition name="fade">
      <div class="loading" v-if="loadingSpin">
          <span class="fa fa-spinner fa-spin"></span> Loading
      </div>
    </transition> -->
    <v-progress-linear v-if="loadingSpin" :indeterminate="loadingSpin" height="3" class="my-0"></v-progress-linear>
    <v-content v-if="!loadingSpin">
      <v-container fluid grid-list-md class="pa-2 container-width">
        <v-layout row wrap justify-center>
          <v-flex lg10 md12 sm12 xs12>
            <v-card>
              <v-card-text>
                <v-layout row wrap style="align-items: center !important;">
                  <v-flex lg6 md6 sm6 xs12>
                    <div class="cut-text" style="text-align:left;">
                        <span style="font-size: 20px;">
                          <strong>{{ getSyndicateName() }} Portfolio</strong>
                        </span>
                      </div>
                  </v-flex>
                  <v-flex lg6 md6 sm6 xs12>
                    <v-autocomplete
                      v-if="userpermission.syndcation_manager"
                      @change="changeSyndicate"
                      v-model="selected_syndicate_id"
                      :items="syndicates"
                      item-text="syndicate_abbreviation"
                      item-value="id"
                      label="Switch View"
                      density="compact"
                      class="dense-select float-right"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-divider class="my-1"></v-divider>
                <div class="d-flex justify-space-between" v-if="!(currentActiveTab == 'simple-view' ||  !(mainSyndicate && mainSyndicate.show_detailed_view_tab))">
                  
                  <!-- <div style="text-align: center;">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                            <b>Total Participation Amt</b>
                            <br/>
                            <span style="color: #7AB648; font-size: 20px; font-weight:bold;">{{(total_participation_amt).toFixed(2) | currency}}</span>
                        </span>
                      </template>
                      <span>Total Participation Amount is the total amount of funds invested in deals</span>
                    </v-tooltip>
                    
                  </div> -->
                  <div style="text-align: center;">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                            <b>Total Anticipated Return</b>
                            <br/>
                            <span style="color: #7AB648; font-size: 20px; font-weight:bold;">{{(total_syndication_part_rtr).toFixed(2) | currency}}</span>
                        </span>
                      </template>
                      <span>Total Anticipated Return(right to receive) is the sum of the anticipated return on invested deals</span>
                    </v-tooltip>
                    
                  </div>
                  <div style="text-align: center;">
                     <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                            <b>Total Investment Cost(Sent in)</b>
                            <br/>
                            <span style="color: #7AB648; font-size: 20px; font-weight:bold;">{{(total_participation_cost).toFixed(2) | currency}}</span>
                        </span>
                      </template>
                      <span>Total Investment Cost(Sent in) is the sum of all expenses (fee and/or commission) incurred when investing in deals</span>
                    </v-tooltip>
                    
                  </div>
                  <div style="text-align: center;">
                     <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                            <b>Portfolio Balance</b>&nbsp;
                            <br/>
                            <span style="color: #7AB648; font-size: 20px; font-weight:bold;">{{(portfolio_balance).toFixed(2) | currency}}</span>
                        </span>
                      </template>
                      <span>Portfolio Balance is the sum of the current remaining balances of your invested deals. Complete with Discount and Write-off deals are not included.</span>
                    </v-tooltip>
                    
                    
                  </div>
                  <div style="text-align: center;">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <b>Total Payouts</b>
                          <br/>
                          <span style="color: #7AB648; font-size: 20px;"><b>{{ parseFloat(total_payouts).toFixed(2) | currency }} </b></span>
                        </span>
                      </template>
                      <span>Total Payouts is the total amount of repayments that you have received</span>
                    </v-tooltip>
                  
                  </div>
                  <div style="text-align: center;">
                    <b>Latest Payout</b>
                    <br/>
                    <span style="color: #7AB648; font-size: 20px;"><b>{{ parseFloat(recent_payouts.sum_net_pay).toFixed(2) | currency }} </b></span>
                    <span style="color: #B5B5B5;">({{ recent_payouts.pay_date }})</span>
                  </div>
                  <div style="text-align: center;" v-if="mainSyndicate && mainSyndicate.is_cash_balance">
                    <b>Cash Balance</b>
                    <br/>
                    <span style="color: #7AB648; font-size: 20px; font-weight:bold;">{{ currentSyndicate.cash_balance | currency}}</span>
                  </div>
                </div>
                <!-- <v-layout row wrap class="py-2" v-if="!(currentActiveTab == 'simple-view' ||  !(mainSyndicate && mainSyndicate.show_detailed_view_tab))">
                 
                  <v-flex lg2 md3 sm6 xs6 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b>Total Participation Amt</b>
                      <br/>
                      <span style="color: #7ab648; font-size: 20px; font-weight:bold;">{{(total_participation_amt).toFixed(2) | currency}}</span>
                    </div>
                  </v-flex>
                  
                  <v-flex lg2 md3 sm6 xs6 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b>Total Participation RTR</b>
                      <br/>
                      <span style="color: #7ab648; font-size: 20px; font-weight:bold;">{{(total_syndication_part_rtr).toFixed(2) | currency}}</span>
                    </div>
                  </v-flex>
                  
                  <v-flex lg2 md3 sm6 xs6 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b>Total Investment Cost(Sent in)</b>
                      <br/>
                      <span style="color: #7ab648; font-size: 20px; font-weight:bold;">{{(total_participation_cost).toFixed(2) | currency}}</span>
                    </div>
                  </v-flex>
                  
                  <v-flex lg2 md3 sm6 xs6 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b>Portfolio Balance</b>&nbsp;
                      <br/>
                      <span style="color: #7ab648; font-size: 20px; font-weight:bold;">{{(portfolio_balance).toFixed(2) | currency}}</span>
                    </div>
                  </v-flex>
                  
                  <v-flex lg2 md3 sm6 xs6 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b>Total Payouts</b>
                      <br/>
                      <span style="color: #7ab648; font-size: 20px;"><b>{{ parseFloat(total_payouts).toFixed(2) | currency }} </b></span>
                    </div>
                  </v-flex>

                  <v-flex lg2 md3 sm6 xs6 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b>Latest Payout</b>
                      <br/>
                      <span style="color: #7ab648; font-size: 20px;"><b>{{ parseFloat(recent_payouts.sum_net_pay).toFixed(2) | currency }} </b></span>
                      <span style="color: #b5b5b5;">({{ recent_payouts.pay_date }})</span>
                    </div>
                  </v-flex>

                  <v-flex lg2 md3 sm6 xs6 class="col-3 col-1" v-if="mainSyndicate && mainSyndicate.is_cash_balance">
                    <div style="text-align: center;">
                      <b>Cash Balance</b>
                      <br/>
                      <span style="color: #7ab648; font-size: 20px; font-weight:bold;">{{ mainSyndicate.cash_balance | currency}}</span>
                    </div>
                  </v-flex>

                </v-layout> -->
                <v-layout row wrap class="py-2" v-else>
                  <v-flex lg4 md4 sm4 xs4 class="col-3 col-1">
                    <div style="text-align: center;">
                      
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">
                            <b style="font-size: 28px;">Total Portfolio Balance:</b>&nbsp;
                            <b style="color: #7ab648; font-size: 28px;">{{(portfolio_balance).toFixed(2) | currency}}</b>&nbsp;
                          </span>
                        </template>
                        <span>Total Portfolio Balance is the sum of the current remaining balances of your invested deals. Complete with Discount and Write-off deals are not included.</span>
                      </v-tooltip>
                      
                      <template v-if="mainSyndicate && mainSyndicate.show_cash_balance">
                        <br/>
                        <span style="color: gray; font-size: 14px; font-weight:bold;">Cash Balance: {{currentSyndicate.cash_balance | currency}}</span>
                      </template>
                    </div>
                  </v-flex>

                  <v-flex lg4 md4 sm4 xs4 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b style="font-size: 28px;">Net Investment: </b>&nbsp;
                      <!-- <b style="color: #7AB648; font-size: 28px;">{{(netInvestment()).toFixed(2) | currency}}</b>&nbsp; -->
                      <b style="color: #7AB648; font-size: 28px;">
                        <template v-if="mainSyndicate && mainSyndicate.is_cash_balance">
                          {{netInvestmentNew | currency}}
                        </template>
                        <template v-else>
                          {{(netInvestment()).toFixed(2) | currency}}
                        </template>
                      </b>&nbsp;
                      <br/>
                      <span style="color: gray; font-size: 14px; font-weight:bold;">Total Investment Cost: {{(total_participation_cost).toFixed(2) | currency}}</span>
                    </div>
                  </v-flex>

                  
                  <v-flex lg4 md4 sm4 xs4 class="col-3 col-1">
                    <div style="text-align: center;">
                      <b style="font-size: 28px;">Portfolio Return:</b>&nbsp;
                      <b style="color: #7ab648; font-size: 28px;">{{(portfolioReturn()).toFixed(2)}}%</b>&nbsp;
                      <br/>
                      <span style="color: gray; font-size: 14px;"><b>Total Payouts: {{ parseFloat(total_payouts).toFixed(2) | currency }} </b></span>
                      <span style="color: gray;">({{ recent_payouts.pay_date }})</span></div>
                  </v-flex>

                </v-layout>

                <v-layout row wrap>
                  <v-flex lg12 md12 sm12 xs12>
                    <vue-tabs ref="vTabsItem" type="pills" :id="getClassOfActiveTabs" @tab-change="handleTabChange">
                      <v-tab title="Simple View" > 
                        <!-- v-if="mainSyndicate && mainSyndicate.show_quick_view_tab" -->
                        <QuickView :syndication_id="syndication_id" v-if="openQuickView"/>
                      </v-tab>
                      <v-tab title="Detailed View" v-if="mainSyndicate && mainSyndicate.show_detailed_view_tab">
                        <DetailedView :syndication_id="syndication_id" v-if="openDetailedView"/>
                      </v-tab>
                      <v-tab class="tab_height" title="Payouts">
                        <payouts @sendRecentPayouts="receiveRecentPayouts" :syndication_id="syndication_id" v-if="payout_status"></payouts>
                      </v-tab>
                      <v-tab title="Syndicated Deals" v-if="mainSyndicate && mainSyndicate.deals_tab">
                        <SyndicatedDeals :syndication_id="syndication_id" v-if="syndicated_deals_status"/>
                      </v-tab>
                      <!-- <v-tab title="Pending Deals">
                        <pending-deal-syndication-test-page v-if="pending_deals_status"/>
                      </v-tab> -->
                    </vue-tabs>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>

        </v-layout>
      </v-container>

      <!-- <AcceptOfferForm /> -->

      <ResetPassword 
        v-if="passwordDialog" 
        @closePasswordDialog="closePasswordDialog" 
        :passwordDialog="passwordDialog" 
      />
    </v-content>
  </div>
</template>

<script>
import axios from "axios";
// import PendingDealSyndicationTestPage from './PendingDealSyndicationTestPage';
import ResetPassword from './Dialogs/ResetPassword'
import SyndicatedDeals from './SyndicatedDeals'
import QuickView from "./QuickView.vue";
import Payouts from './Payouts.vue';
import {URL, config} from '../../env'
import _ from "lodash";
import user_helper from '../helpers/user_helper';
import DetailedView from "./DetailedView.vue";
// import global_helper from '../helpers/global_helper';

// import AcceptOfferForm from "./AcceptOfferForm.vue";

export default {
  mixins:[user_helper],
  components: {
    // 'pending-deal-syndication-test-page': PendingDealSyndicationTestPage,
    Payouts,
    SyndicatedDeals,
    QuickView,
    DetailedView,
    ResetPassword,
    // AcceptOfferForm,
  },

  data() {
    return {
      currentActiveTab: 'simple-view',
      passwordDialog: false,
      payout_status: true,
      syndicated_deals_status: true,
      openQuickView: true,
      openDetailedView: false,
      pending_deals_status: false,
      syndication_id: localStorage.getItem('syndication_id'),
      total_participation_amt: 0,
      total_syndication_part_rtr:0 ,
      total_participation_cost: 0 ,
      portfolio_balance: 0,
      recent_payouts: {},
      total_payouts: 0,
      netInvestmentNew: 0,
      first_login: localStorage.getItem("first_login")
    };
  },

  mounted(){
    this.getSums()
    if(this.first_login == 'true'){
      this.passwordDialog = true
    }
    // console.log(this.$refs.vTabsItem.$children)
    // debugger
  },
  computed: {
    getClassOfActiveTabs(){
      if(!this.mainSyndicate) return 'thetabs'
      if(this.mainSyndicate.show_quick_view_tab && !this.mainSyndicate.show_detailed_view_tab)return 'twotabs'
      if(this.mainSyndicate.show_quick_view_tab && this.mainSyndicate.show_detailed_view_tab) return 'anyOnetabs'//'alltabs'
      else if(this.mainSyndicate.show_quick_view_tab || this.mainSyndicate.show_detailed_view_tab) return 'anyOnetabs'
      else return 'thetabs'
    },
  },
  
  methods:{
    portfolioReturn() {
      let netInvestment = this.netInvestment()
      let portfolio_balance = this.portfolio_balance
      let cash_balance = this.currentSyndicate && this.currentSyndicate.cash_balance ? this.currentSyndicate.cash_balance :  0
      if(netInvestment != 0){
        return ((parseFloat(portfolio_balance) - parseFloat(netInvestment) + parseFloat(cash_balance)) / netInvestment) * 100
      } else {
        return 0
      }
    },
    netInvestment(){
      if(this.currentSyndicate && this.currentSyndicate.is_cash_balance) {
        return this.total_participation_cost - this.total_payouts + parseFloat(this.currentSyndicate.cash_balance)
      } else {
        return this.total_participation_cost - this.total_payouts + parseFloat(this.currentSyndicate.cash_balance)
      }
    },
    closePasswordDialog() {
      this.passwordDialog = false;
    },
    receiveRecentPayouts(item){
      this.recent_payouts = item
    },
    handleTabChange(tabIndex, newTab, oldTab){
      if(tabIndex == 0){
        this.openQuickView = true
        this.currentActiveTab = 'simple-view'
      }else if(tabIndex == 1){
        this.openDetailedView = true
        this.currentActiveTab = null
        
      }
      // else if(tabIndex == 2){
      //   this.pending_deals_status = true
      // }
      else if(tabIndex == 2){
        this.payout_status= true
        this.currentActiveTab = null
        
      }else if(tabIndex == 3){
        this.syndicated_deals_status = true
        this.currentActiveTab = null
      }
    },
    getSyndicateName() {
      return localStorage.getItem("name");
    },
    getSums(){
      axios.get(`${URL}/api/payouts/syndication_sums/`+this.syndication_id).then(res=>{
        // this.recent_payouts = (res.data.recent_payouts.length > 0) ? res.data.recent_payouts[0] : {}
        this.total_participation_amt = (res.data.sums.length>0) ? parseFloat(res.data.sums[0].total_participation_amt) : 0 
        this.total_syndication_part_rtr = (res.data.sums.length>0) ? parseFloat(res.data.sums[0].total_syndication_part_rtr) : 0
        this.total_participation_cost = (res.data.sums.length>0) ? parseFloat(res.data.sums[0].total_participation_cost) : 0
        this.portfolio_balance = (res.data.sums.length>0) ? parseFloat(res.data.sums[0].portfolio_balance) : 0
        this.total_payouts = res.data.total_payouts ? parseFloat(res.data.total_payouts) : 0
        this.netInvestmentNew = res.data.netInvestmentNew ? parseFloat(res.data.netInvestmentNew) : 0
      })
    }
  }
};
</script>

<style scoped>

/* table.v-table tbody td, table.v-table tbody th {
    height: 30px!important;
} */

.container-width {
  max-width: 100% !important;
}

.custom-width {
    width: 12% !important;
    font-size: 12px !important;
  }

.custom-width-2 {
  width: 15% !important;
}

@media screen and (max-width: 750px) {
  .custom-width {
    width: 20% !important;
  }
}

/* .nav-item {
  text-align: center;
}
.nav-item button {
  padding: 5px;
  text-align: left;
  font-size: 11px;
  line-height: 1.5;
  font-weight: 400;
  width: 100%;
  margin: 0;
  margin-bottom: 7px;
} */

/* Hide scrollbar for Chrome, Safari and Opera */
.overflow-section::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE and Edge */
.overflow-section {
  -ms-overflow-style: none;
}

.overflow-section {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 540px;
  max-height: 540px;
}

.side-list {
  font-size: 13px !important;
  height: 100%;
  font-weight: bold !important;
}

.th-style {
  height: 25px !important; 
  text-align: left; 
  color: #000;
}

</style>

<style>

.theme--light.v-text-field--outline>.v-input__control>.v-input__slot{
  border: 1px solid rgba(68, 68, 68, 0.4) !important;
}
#thetabs.vue-tabs .nav-pills > li {
    width: 32% !important;
}
#alltabs.vue-tabs .nav-pills > li {
    width: 19% !important;
}

#anyOnetabs.vue-tabs .nav-pills > li {
    /* width: 24% !important; */
    min-width: 157px;
}
#twotabs.vue-tabs .nav-pills > li {
    width: 49% !important;
}

@media screen and (max-width:600px) {
  #thetabs.vue-tabs .nav-pills > li.active > a{
    height: 56px !important;
  }

  #thetabs.vue-tabs .nav-pills > li > a{
    height: 56px !important;
  }

  #thetabs .title
  {
    margin-top: 5px !important;
  }

  #alltabs.vue-tabs .nav-pills > li.active > a{
    height: 56px !important;
  }

  #alltabs.vue-tabs .nav-pills > li > a{
    height: 56px !important;
  }

  #alltabs .title
  {
    margin-top: 5px !important;
  }

  #anyOnetabs.vue-tabs .nav-pills > li.active > a{
    height: 56px !important;
  }

  #anyOnetabs.vue-tabs .nav-pills > li > a{
    height: 56px !important;
  }

  #anyOnetabs .title
  {
    margin-top: 5px !important;
  }

  #twotabs.vue-tabs .nav-pills > li.active > a{
    height: 56px !important;
  }
  #twotabs.vue-tabs .nav-pills > li > a{
    height: 56px !important;
  }
  #twotabs .title
  {
    margin-top: 5px !important;
  }
}

#thetabs.vue-tabs .nav-pills > li.active > a{
   color: white;
    background-color: black;
   
}

#thetabs.vue-tabs .tabs__link {
    color: #000;
    background-color: #bfbfbf;
}

#alltabs.vue-tabs .nav-pills > li.active > a{
   color: white;
    background-color: black;
   
}

#alltabs.vue-tabs .tabs__link {
    color: #000;
    background-color: #bfbfbf;
}

#anyOnetabs.vue-tabs .nav-pills > li.active > a{
   color: white;
    background-color: black;
   
}

#anyOnetabs.vue-tabs .tabs__link {
    color: #000;
    background-color: #bfbfbf;
}

#twotabs.vue-tabs .nav-pills > li.active > a{
  color: white;
  background-color: black;  
}

#twotabs.vue-tabs .tabs__link {
    color: #000;
    background-color: #bfbfbf;
}




#search .v-input__slot {
  margin-bottom: 0px !important;
  min-height: 30px !important;
  height: 30px !important;
}

#search .v-input__control {
  height: 30px !important;
}

#search .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}

#search
  .v-text-field.v-text-field--enclosed
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
}

#search .v-text-field--outline.v-text-field--single-line input {
    margin-top: 0px !important;
}

#select .v-input__slot {
  margin-bottom: 0px !important;
  min-height: 30px !important;
  height: 30px !important;
}

#select .v-text-field.v-text-field--enclosed .v-input__append-inner {
    margin-top: 0px;
}

#select .v-input .v-label {
  position: static !important;
}

#select .v-menu>.v-menu__content {
    top: 0px !important;
    left: 0px !important;
}

#select .v-select__selection {
    max-width: 100%;
}

/* #dashboard table.v-table thead th {
    padding: 0px !important;
} */

#dashboard .v-pagination {
    float: left;
}

#dashboard .v-select__selection--comma {
    margin: 0px;
}

#dashboard .v-input {
  font-size: 14px;
}

#thetabs .title {
  font-size: 16px !important;
}

#alltabs .title {
  font-size: 16px !important;
}

</style>

<style scoped>
@media screen and (min-width: 600px) {
  .float-right {
    float: right;
  }
}

.dense-select {
  max-height: 34px !important;
  padding-top: 0px !important;
  margin-top: 0px !important;
}

@media screen and (min-width: 600px) {
  .dense-select {
    width: 250px !important;
  }
}

@media screen and (min-width: 700px) and (max-width: 1100px) {
  .col-3 {
    flex-basis: 33% !important;
    flex-grow: 0 !important;
    max-width: 33% !important;
  }
}

@media screen and (max-width: 500px) {
  .col-1 {
    flex-basis: 100% !important;
    flex-grow: 0 !important;
    max-width: 100% !important;
  }
}

.cut-text { 
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
}

</style>